module.exports = __webpack_public_path__ + "img/科研单位.712c97ff.png";